<template>
    <div class="vue-dropdown relative">
        <button v-on:click="open = !open" class="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 cursor-pointer">
            <span v-text="label"></span>
            <svg width="8" height="6" fill="none" class="ml-2.5 text-gray-400">
                <path d="M7 1.5l-3 3-3-3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
        </button>
        <div v-show="open" class="origin-bottom-left absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="user-menu-button" tabindex="-1">
            <div class="divide-y divide-gray-100">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['label'],
        data: function() {
            return {
                open: false,
            };
        },
        mounted: function() {
            //
        },
        computed: {
            //
        },
        methods: {
            //
        }
    }
</script>
